<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>渠道</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
            <el-card shadow="hover"  class="containCard" >

                <div class='navShow' v-for="(item,index) in tableData">
                    <p class='navShow-title' @click='showLi(index)'><i class='el-icon-coin' style='margin-right:10px'></i>{{item.tname}} <span class=''><i :class="'el-icon-caret-bottom navShow-i'+index"></i></span></p>
                    <ul>
                        <li :class="'navShow-li'+index" v-for="item2 in item.subs">
                            <img :src='item2.icon'  />
                            <div class='navShow-imgLayer'>
                                <el-tooltip class="item" effect="light" content="复制网址" placement="bottom-start">
                                    <i class='el-icon-document-copy' @click='copyText(item2.link)'></i>
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" content="打开网址" placement="bottom-start">
                                    <i class='el-icon-paperclip' @click='open(item2)'></i>
                                </el-tooltip>
                            </div>
                            <p style='font-size:15px;font-weight:700;text-align: center;'>{{item2.name}}</p>
                            <p style='font-size: 12px;'>账号：<el-link @click='copyText(item2.user)'>{{item2.user}}</el-link></p>
                            <p style='font-size: 12px;'>密码：<el-link @click='copyText(item2.password)'>{{item2.password}}</el-link></p>
                            <p style='font-size: 12px;'>备注：<el-link @click='copyText(item2.remarks)'>{{item2.remarks}}</el-link></p>
                        </li>
                        <div style='clear:both'></div>
                    </ul>

                </div>
                <div style="clear:both"></div>
        </el-card>
          
    </div>
</template>

<script>
import $ from 'jquery';
import bus from '../../../components/common/bus';
import vContent2 from './NavLink.vue';
import {getListTree} from '../../../api/navType';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            showVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                wtype:'1',
                fb1:10,
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
        bus.$on('image-choose',  url  => {
            this.form1.icon = url;
            this.form3.icon = url;
            this.showVisible = false;
        });
    },
    components: {
        vContent2,
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();
        //this.getSelect();
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        open(data){
            if(data.wtype==0){
                this.$router.push({
                    path: '/navLink',
                    query: { url: encodeURIComponent(data.link) } // 编码防止特殊字符
                });
            }else{
                window.open(data.link);
            }
        },
        copyText(text){
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success("网址链接已复制");
        },
        showLi(i){
            var display = $('.navShow-li'+i).css('display');
            if(display=='none'){
                $('.navShow-li'+i).css('display','block');
                $('.navShow-i'+i).attr('class','el-icon-caret-bottom navShow-i'+i);
            }else{
                $('.navShow-li'+i).css('display','none');
                $('.navShow-i'+i).attr('class','el-icon-caret-right navShow-i'+i);
            }

        },
        getSelect(){
            this.select.option = '';
            fetchSelect(this.select).then(res => {
                if(res.code=='200'){
                    this.select.option = res.data;
                }
            });
        }, 
        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'name', '');  
            this.$set(this.query, 'status');    
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){
            getListTree(this.query).then(res => {
                if(res.code=='200'){ 
                    this.tableData = res.data;
                }else{
                    this.$message(res.message);
                } 
                
            });
        },
        //渠道字典表
        channelDir(){
            this.dirVisible=true;
            fetchDataDir(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData2 = res.data;   
                }else{
                    this.$message("暂无数据");
                } 
                
            });

        },
       

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写导航名称");
                return;
            }if( !this.form1.icon ){
                this.isSubmitting = false;
                this.$message.error("请选择导航图标");
                return;
            }if( !this.form1.tid ){
                this.isSubmitting = false;
                this.$message.error("请选择导航分类");
                return;
            }
            this.addVisible = false;  
            this.loading = true; 
            saveForm(this.form1).then(res => {
                this.loading = false; 
                this.isSubmitting = false;
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                    this.refreshSearch(); 
                }else{
                    this.addVisible = true;  
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form3 = row;
        },
 
        
        // 保存更改
        saveEdit() {   
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                row.status='1';
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                row.status = '0';
                tips = "启用";
                content = "确定启用吗？"; 
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => { 
                if(row.status=='0'){ 
                    row.status='1' 
                }else{ 
                    row.status='0' 
                }
                changeStatus(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success(tips+'成功'); 
                        this.getData();
                    }else{ 
                        if(row.status=='0'){ 
                            row.status='1' 
                        }else{ 
                            row.status='0' 
                        }
                        this.$message.error(tips+'失败');
                    } 
                });
            })
            .catch(() => {}); 
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该渠道商品仍有订单未结算，请手动结算订单！"); 
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
